<script lang="ts" setup>
defineProps<{ data: Business }>()
const open = defineModel<boolean>('open', { default: false })
</script>

<template>
  <UModal v-model="open" :ui="{ rounded: 'rounded-2xl overflow-clip' }">
    <div class="p-4 md:p-8 lg:p-12 bg-darkblue flex justify-center items-center flex-col">
      <HeadingText tag="h3" class="text-pink">
        Get In Touch
      </HeadingText>
      <p class="text-white pt-2 pb-6">
        {{ data.name }} can be contacted by the following methods:
      </p>
      <CollectionBusinessSocials :business="data" class="pt-6 justify-center" />
    </div>
  </UModal>
</template>
